import hyperdom from 'hyperdom'
import assetPath from './assetPath.js'

export default ({content, config, calculatePositionCallback}) => {
  const tooltipImg = assetPath(`/public/img/${config.styleCode}/icon-tooltip.svg`)
  const openTooltip = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()
    closeTooltips()

    const target = ev.target.nextElementSibling
    target.style.display = 'flex'

    if (calculatePositionCallback) {
      calculatePositionCallback(target)
    }
  }

  const closeTooltips = () => {
    document
      .querySelectorAll('.generic-tooltip__content')
      .forEach(el => {
        el.style.display = 'none'
      })
  }

  return <div className="generic-tooltip">
    <img src={tooltipImg} alt='tooltip-icon' onclick={openTooltip}/>
    <div className="generic-tooltip__content">
      <span>{content}</span>
      <span className='close-btn' onclick={closeTooltips}></span>
    </div>
  </div>
}



